'use client';
import {useRouter} from 'next/navigation';
import {Row, Col, Button} from 'antd';
import Image from 'next/image';

export default function NotFound() {
  const router = useRouter();

  return (
    <Row className='notFound' align='middle' justify='center'>
      <Col>
        <Image src='/img/404.svg' alt='404 Page check' width={100} height={100} />
        <div className='message'>Looks like the page you’re trying to access does not exist.</div>
        <Button className='button' onClick={() => router.back()}>Go Back to Previous Page</Button>
      </Col>
    </Row>
  );
}
